import { useEffect, useState, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import styles from "./Navbar.module.css";
import logo1 from "../../assets/logo1.png";
import navbarBackground from "../../assets/NavbarBackground.png";
import PopUp from "../Login/PopUp.jsx";
import { assests } from "../../assets/assests";
import { LanguageContext } from "../LanguageContext/LanguageContext";
import axios from "axios";
import loginarrow from "../../assets/Arrow.png";
import auth from "../../Auth/Auth.js";
import { ScaleLoader } from "react-spinners";
import { usePopupContext } from "../Login/PopupContext.jsx";
import { FaShoppingCart } from "react-icons/fa";
import CustomCartIcon from '../../components/CustomCartIcon';

const userPhoto = localStorage.getItem("currentuserImg");
const defaultProfileImg = "https://preprodhome.maflam.com/theme/image.php/remui/core/1751462196/u/f1";

const Navbar = () => {
  // Only set user if authenticated
  const isAuthenticated = auth.isAuthenticated();
  const userDetails = isAuthenticated ? auth.getAuthData() : null;
  const [openDropdown, setOpenDropdown] = useState(null);
  const [isHamburgerOpen, setIsHamburgerOpen] = useState(false);
  const [navItems1, setNavItems1] = useState([]);
  const [user, setUser] = useState(userDetails);
  const [isProfileMenuOpen, setIsProfileMenuOpen] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [profileMenuItems, setProfileMenuItems] = useState([]);
  const navigate = useNavigate();
  const { language, direction, toggleLanguage } = useContext(LanguageContext);
  const [isErrorComponentVisible, setIsErrorComponentVisible] = useState(false);
  const { popupData, setPopupValues } = usePopupContext();
  const marketingBackendUrl = import.meta.env.VITE_MARKETING_BACKEND_URL;
  const lmsUrl = import.meta.env.VITE_LMS_URL;

  const toggleDropdown = (dropdownName) => {
    setOpenDropdown(openDropdown === dropdownName ? null : dropdownName);
  };

  const toggleHamburger = () => {
    setIsHamburgerOpen(!isHamburgerOpen);
  };

  const toggleProfileMenu = () => {
    setIsProfileMenuOpen(!isProfileMenuOpen);
  };

  const placeHolderTitle =
    language === "ar" ? "ابحث عن دورات تدريبية..." : "Search for courses...";

  const arrow =
    language === "ar" ? (
      <img src={loginarrow} alt="" style={{ marginRight: "10px" }} />
    ) : (
      <img src={loginarrow} alt="" style={{ marginRight: "10px" }} />
    );

  const FooterGetApi = (lang) => {
    axios
      .get(`${marketingBackendUrl}/maflam/fetch-nav-item?lang=${lang}`)
      .then((response) => {
        setNavItems1(response.data);

        const profileData = response.data.find(
          (item) => item.headerSubCategory
        );
        if (profileData) {
          setProfileMenuItems(profileData.headerSubCategory);
        }
      })
      .catch((error) => {
        console.error("Error fetching footer data:", error);
      });
  };

  useEffect(() => {
    FooterGetApi(language === "ar" ? 0 : 1);
    // Only set user if authenticated
    if (isAuthenticated) {
      setUser(auth.getAuthData());
    } else {
      setUser(null);
    }
    // No fallback to fullname/currentusername for guest users
  }, [language, isAuthenticated]);

  // Function to refresh user data from localStorage (only if authenticated)
  const refreshUserData = () => {
    if (isAuthenticated) {
      setUser(auth.getAuthData());
    } else {
      setUser(null);
    }
  };

  // Function to fetch user profile from backend if needed (only if authenticated)
  const fetchUserProfile = async () => {
    if (!isAuthenticated) return;
    try {
      const userEmail = localStorage.getItem("useremailidis");
      if (userEmail && !localStorage.getItem("currentusername")) {
        const response = await axios.get(`${marketingBackendUrl}/maflam/profile/${userEmail}`);
        if (response.data.profile) {
          localStorage.setItem("currentusername", response.data.profile.name);
          refreshUserData();
        }
      }
    } catch (error) {
      console.error("Error fetching user profile:", error);
    }
  };

  // Add event listener for window focus to refresh user data
  useEffect(() => {
    const handleFocus = () => {
      refreshUserData();
    };

    window.addEventListener('focus', handleFocus);
    return () => window.removeEventListener('focus', handleFocus);
  }, [isAuthenticated]);

  // Periodic refresh of user data (every 5 seconds, only if authenticated)
  useEffect(() => {
    if (!isAuthenticated) return;
    const interval = setInterval(() => {
      refreshUserData();
    }, 5000);

    return () => clearInterval(interval);
  }, [isAuthenticated]);

  const handleLogoutClick = () => {
    auth.logout();
    localStorage.removeItem("user");
    setUser(null);
    navigate("/home/login");
  };

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 767);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleSearch = (searchTerm) => {
    const searchTermLower = searchTerm.toLowerCase();
    if (
      searchTermLower === "full package" ||
      searchTermLower === "package" ||
      searchTermLower === "bundle"
    ) {
      navigate("/home/R2/bundle");
    } else if (
      searchTermLower === "script" ||
      searchTermLower === "script writing"
    ) {
      navigate("/home/R2/R4/filmproduction/67991471f6a6c8891dd9b40d");
    } else if (searchTermLower === "editing") {
      navigate("/home/R2/R3/prc/All?category=Editing");
    } else if (searchTerm) {
      axios
        .get(`${marketingBackendUrl}/maflam/courses-light`)
        .then((response) => {
          const courses = response.data.courses;
          const course = courses.find((course) =>
            course.CourseNameEnglish.toLowerCase().includes(
              searchTerm.toLowerCase()
            )
          );
          if (course) {
            navigate(`/home/R2/R4/filmproduction/${course._id}`);
          }
        })
        .catch((error) => {
          console.error("Error fetching courses:", error);
        });
    }
    if (isMobile) setIsHamburgerOpen(false);
  };

  return (
    <div
      className={styles.navmenu}
      style={{ backgroundImage: `url(${navbarBackground})` }}
    >
      {isErrorComponentVisible && (
        <div
          style={{
            position: "absolute",
            top: "0px",
            width: "100%",
            margin: "auto",
          }}
        >
          <PopUp
            titleEN={popupData.titleEN}
            titleAR={popupData.titleAR}
            descriptionEN={popupData.descriptionEN}
            descriptionAR={popupData.descriptionAR}
            buttonText1EN={popupData.buttonText1EN}
            buttonText1AR={popupData.buttonText1AR}
            buttonText2EN={popupData.buttonText2EN}
            buttonText2AR={popupData.buttonText2AR}
            linkText1EN={popupData.linkText1EN}
            linkText1AR={popupData.linkText1AR}
            linkText2EN={popupData.linkText2EN}
            linkText2AR={popupData.linkText2AR}
            button1Link={popupData.button1Link}
            button2Link={popupData.button2Link}
          />
        </div>
      )}
      <nav
        className={`${styles.navbar} ${isHamburgerOpen ? styles.active : ""}`}
      >
        <Link
          onClick={() => {
            setOpenDropdown(null);
            setIsHamburgerOpen(false);
          }}
          to="home/"
        >
          <img src={logo1} alt="Logo" className={styles.logo} />
        </Link>
        <div className={styles.menuelements}>
          <div className={styles.leftLinks}>
            {navItems1.map((item, index) => (
              <div key={index} className={`${styles.dropdown} ${openDropdown === item.name ? styles.dropdownOpen : ''}`}>
                {item.hasDropdown ? (
                  <div
                    className={styles.dropdownContainer}
                    onMouseEnter={
                      !isMobile ? () => setOpenDropdown(item.name) : undefined
                    }
                    onMouseLeave={
                      !isMobile ? () => setOpenDropdown(null) : undefined
                    }
                    onClick={
                      isMobile
                        ? () =>
                            setOpenDropdown(
                              openDropdown === item.name ? null : item.name
                            )
                        : undefined
                    }
                    style={{ position: "relative" }}
                  >
                    <h1
                      style={{
                        height: "100%",
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                      className={
                        openDropdown === item.name ? styles.activeLink : ""
                      }
                    >
                      {item.name}
                      <span
                        className={`${styles.arrow} ${
                          openDropdown === item.name
                            ? language === "ar"
                              ? styles.rotate
                              : styles.rotate1
                            : ""
                        }`}
                      >
                        &#8595;
                      </span>
                    </h1>

                    {openDropdown === item.name && (
                      <div
                        className={`${styles.submenu} ${language === 'ar' ? styles.submenuArb : ''}`}
                        onMouseEnter={
                          !isMobile
                            ? () => setOpenDropdown(item.name)
                            : undefined
                        }
                        onMouseLeave={
                          !isMobile ? () => setOpenDropdown(null) : undefined
                        }
                        style={{
                          position: "absolute",
                          top: "100%",
                          left: 0,
                          zIndex: 1000,
                          borderRadius: "4px",
                          boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                        }}
                      >
                        {item.dropdownItems?.map((subItem, subIndex) => (
                          <Link
                            to={subItem.href}
                            key={subIndex}
                            className={styles.dropdownitems}
                            onClick={() => {
                              setOpenDropdown(null);
                              setIsHamburgerOpen(false);
                            }}
                          >
                            &nbsp;&nbsp;
                            <img
                              className={
                                language === "ar"
                                  ? styles.subIcon
                                  : styles.subIconArb
                              }
                              src={subItem.icon}
                              alt=""
                            />
                            {subItem.name}
                          </Link>
                        ))}
                      </div>
                    )}
                  </div>
                ) : (
                  <Link
                    to={item.href}
                    onClick={() => {
                      setOpenDropdown(null);
                      setIsHamburgerOpen(false);
                    }}
                  >
                    {item.name}
                  </Link>
                )}
              </div>
            ))}
          </div>
          <div className={styles.searchContainer}>
            <input
              type="text"
              placeholder={placeHolderTitle}
              value={searchValue}
              onChange={e => setSearchValue(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleSearch(searchValue);
                }
              }}
            />
            <button
              className={styles.searchButton}
              onClick={e => {
                e.preventDefault();
                handleSearch(searchValue);
              }}
            >
              <img src={assests.Magnifine} alt="Search Icon" />
            </button>
          </div>
          <div className={styles.rightLinks}>
            {isAuthenticated && (!isMobile || localStorage.getItem("currentusername")) && user ? (
              <div className={styles.profileContainer}>
                <div className={styles.profile}>
                  <span
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: "12px",
                      padding: "8px 12px",
                      cursor: "pointer"
                    }}
                    onClick={() => {
                      toggleProfileMenu();
                      setOpenDropdown(null);
                    }}
                  >
                    <div style={{
                      width: "32px",
                      height: "32px",
                      borderRadius: "50%",
                      overflow: "hidden",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center"
                    }}>
                      <img
                        src={userPhoto || defaultProfileImg}
                        alt="Profile"
                        className={styles.profileImage}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover"
                        }}
                        onError={e => { e.target.onerror = null; e.target.src = defaultProfileImg; }}
                      />
                    </div>
                    <span 
                      className={styles.username}
                      style={{
                        fontSize: "15px",
                        fontWeight: "500",
                        lineHeight: "20px",
                        display: "block"
                      }}
                    >
                      {localStorage.getItem("currentusername") ||
                        user?.usernameInEng ||
                        user?.fullName ||
                        localStorage.getItem("fullname") ||
                        "User"}
                    </span>
                  </span>
                  <span>
                    {profileMenuItems.length > 0 && (
                      <span key={0} style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '20px',
                        padding: '10px 20px',
                        minHeight: '40px'
                      }}>
                        <div style={{
                          width: '18px',
                          height: '18px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}>
                          <img
                            src={profileMenuItems[0].icon}
                            alt={profileMenuItems[0].name}
                            className={styles.subIcon}
                            style={{ 
                              width: '16px',
                              height: '16px',
                              objectFit: 'contain',
                              display: 'block'
                            }}
                          />
                        </div>
                        {profileMenuItems[0].name === "Log out" ||
                        profileMenuItems[0].name === "تسجيل الخروج" ? (
                          <span 
                            onClick={handleLogoutClick}
                            style={{
                              fontSize: '15px',
                              cursor: 'pointer',
                              lineHeight: '18px'
                            }}
                          >
                            {profileMenuItems[0].name}
                          </span>
                        ) : (
                          <a
                            href={
                              localStorage.getItem("courseCount") > 0
                                ? `${lmsUrl}/my/courses.php?lang=ar`
                                : "#"
                            }
                            style={{
                              fontSize: '15px',
                              textDecoration: 'none',
                              color: '#ffffff',
                              lineHeight: '18px'
                            }}
                            onClick={() => {
                              if (localStorage.getItem("courseCount") == 0) {
                                setIsErrorComponentVisible(true);
                                setPopupValues("NotASubscriber");
                              }
                              setIsHamburgerOpen(false);
                            }}
                          >
                            {profileMenuItems[0].name}
                          </a>
                        )}
                      </span>
                    )}
                  </span>
                </div>
                {isProfileMenuOpen && (
                  <div
                    className={styles.profileMenu}
                    onClick={() => {
                      toggleProfileMenu();
                      setOpenDropdown(null);
                    }}
                  >
                    <ul>
                      {/* First menu item (Personal Information) */}
                      {profileMenuItems.slice(1, 2).map((item, index) => (
                        <li key={index} style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '24px',
                          padding: '12px 24px',
                          minHeight: '48px',
                          position: 'relative',
                          cursor: 'pointer',
                          transition: 'all 0.2s ease'
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = 'rgba(57, 255, 251, 0.05)';
                          e.currentTarget.querySelector('a').style.color = '#39FFFB';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = 'transparent';
                          e.currentTarget.querySelector('a').style.color = 'inherit';
                        }}>
                          <div style={{
                            width: '20px',
                            height: '20px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            flexShrink: 0
                          }}>
                            <img
                              src={item.icon}
                              alt={item.name}
                              className={styles.subIcon}
                              style={{ 
                                width: '18px',
                                height: '18px',
                                objectFit: 'contain',
                                display: 'block'
                              }}
                            />
                          </div>
                          <Link
                            to={
                              localStorage.getItem("courseCount") > 0
                                ? "/home/personalInformation"
                                : "#"
                            }
                            style={{
                              fontSize: '15px',
                              textDecoration: 'none',
                              color: 'inherit',
                              lineHeight: '24px',
                              display: 'block',
                              fontWeight: '500',
                              transition: 'color 0.2s ease'
                            }}
                            onClick={() => {
                              if (localStorage.getItem("courseCount") == 0) {
                                setIsErrorComponentVisible(true);
                                setPopupValues("canteditProfile");
                              }
                              toggleProfileMenu();
                              setOpenDropdown(null);
                              setIsHamburgerOpen(false);
                            }}
                          >
                            {item.name}
                          </Link>
                        </li>
                      ))}

                      {/* My Certificates menu item */}
                      <li style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '24px',
                        padding: '12px 24px',
                        minHeight: '48px',
                        position: 'relative',
                        cursor: 'pointer',
                        transition: 'all 0.2s ease'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = 'rgba(57, 255, 251, 0.05)';
                        e.currentTarget.querySelector('a').style.color = '#39FFFB';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = 'transparent';
                        e.currentTarget.querySelector('a').style.color = 'inherit';
                      }}>
                        <div style={{
                          width: '20px',
                          height: '20px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          flexShrink: 0
                        }}>
                          <svg
                            width="18"
                            height="18"
                            viewBox="0 0 15 12"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            style={{
                              display: 'block'
                            }}
                          >
                            <path
                              d="M12.75 0.75H2.25C1.65326 0.75 1.08097 0.987053 0.65901 1.40901C0.237053 1.83097 0 2.40326 0 3V9C0 9.59674 0.237053 10.169 0.65901 10.591C1.08097 11.0129 1.65326 11.25 2.25 11.25H12.75C13.3467 11.25 13.919 11.0129 14.341 10.591C14.7629 10.169 15 9.59674 15 9V3C15 2.40326 14.7629 1.83097 14.341 1.40901C13.919 0.987053 13.3467 0.75 12.75 0.75ZM6.75 8.25H3.75C3.55109 8.25 3.36032 8.17098 3.21967 8.03033C3.07902 7.88968 3 7.69891 3 7.5C3 7.30109 3.07902 7.11032 3.21967 6.96967C3.36032 6.82902 3.55109 6.75 3.75 6.75H6.75C6.94891 6.75 7.13968 6.82902 7.28033 6.96967C7.42098 7.11032 7.5 7.30109 7.5 7.5C7.5 7.69891 7.42098 7.88968 7.28033 8.03033C7.13968 8.17098 6.94891 8.25 6.75 8.25ZM11.25 8.25H9.75C9.55109 8.25 9.36032 8.17098 9.21967 8.03033C9.07902 7.88968 9 7.69891 9 7.5C9 7.30109 9.07902 7.11032 9.21967 6.96967C9.36032 6.82902 9.55109 6.75 9.75 6.75H11.25C11.4489 6.75 11.6397 6.82902 11.7803 6.96967C11.921 7.11032 12 7.30109 12 7.5C12 7.69891 11.921 7.88968 11.7803 8.03033C11.6397 8.17098 11.4489 8.25 11.25 8.25ZM13.5 3.75H1.5V3C1.5 2.80109 1.57902 2.61032 1.71967 2.46967C1.86032 2.32902 2.05109 2.25 2.25 2.25H12.75C12.9489 2.25 13.1397 2.32902 13.2803 2.46967C13.421 2.61032 13.5 2.80109 13.5 3V3.75Z"
                              fill="#39FFFB"
                            />
                          </svg>
                        </div>
                        <Link
                          to={
                            localStorage.getItem("courseCount") > 0
                              ? "/home/Mycertificate"
                              : "#"
                          }
                          style={{
                            fontSize: '15px',
                            textDecoration: 'none',
                            color: 'inherit',
                            lineHeight: '24px',
                            display: 'block',
                            fontWeight: '500',
                            transition: 'color 0.2s ease'
                          }}
                          onClick={() => {
                            if (localStorage.getItem("courseCount") == 0) {
                              setIsErrorComponentVisible(true);
                              setPopupValues("NotASubscriber");
                            }
                            toggleProfileMenu();
                            setOpenDropdown(null);
                            setIsHamburgerOpen(false);
                          }}
                        >
                          {direction === "rtl" ? "شهاداتي" : "My Certificates"}
                        </Link>
                      </li>

                      {/* My Wishlist menu item */}
                      <li style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '24px',
                        padding: '12px 24px',
                        minHeight: '48px',
                        position: 'relative',
                        cursor: 'pointer',
                        transition: 'all 0.2s ease'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = 'rgba(57, 255, 251, 0.05)';
                        e.currentTarget.querySelector('a').style.color = '#39FFFB';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = 'transparent';
                        e.currentTarget.querySelector('a').style.color = 'inherit';
                      }}>
                        <div style={{
                          width: '20px',
                          height: '20px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          flexShrink: 0
                        }}>
                          <svg
                            width="18"
                            height="18"
                            viewBox="0 0 15 12"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            style={{
                              display: 'block'
                            }}
                          >
                            <path
                              d="M7.5 13.35L6.5625 12.5C3.375 9.625 1.25 7.7 1.25 5.375C1.25 3.45 2.8 1.9 4.725 1.9C5.825 1.9 6.875 2.4 7.5 3.175C8.125 2.4 9.175 1.9 10.275 1.9C12.2 1.9 13.75 3.45 13.75 5.375C13.75 7.7 11.625 9.625 8.4375 12.5L7.5 13.35Z"
                              fill="#39FFFB"
                            />
                          </svg>
                        </div>
                        <Link
                          to="/home/wishlist"
                          style={{
                            fontSize: '15px',
                            textDecoration: 'none',
                            color: 'inherit',
                            lineHeight: '24px',
                            display: 'block',
                            fontWeight: '500',
                            transition: 'color 0.2s ease'
                          }}
                          onClick={() => {
                            toggleProfileMenu();
                            setOpenDropdown(null);
                            setIsHamburgerOpen(false);
                          }}
                        >
                          {direction === "rtl" ? "قائمة رغباتي" : "My Wishlist"}
                        </Link>
                      </li>

                      {/* Logout item */}
                      {profileMenuItems
                        .slice(2)
                        .filter(
                          (item) =>
                            item.name === "Log out" ||
                            item.name === "تسجيل الخروج"
                        )
                        .map((item, index) => (
                          <li key={index} style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '90px',
                            padding: '12px 24px',
                            minHeight: '48px',
                            position: 'relative',
                            flexDirection: 'row',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease'
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = 'rgba(57, 255, 251, 0.05)';
                            e.currentTarget.querySelector('span').style.color = '#39FFFB';
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = 'transparent';
                            e.currentTarget.querySelector('span').style.color = 'inherit';
                          }}>
                            <span
                              style={{
                                fontSize: '15px',
                                cursor: 'pointer',
                                lineHeight: '24px',
                                display: 'block',
                                fontWeight: '500',
                                transition: 'color 0.2s ease'
                              }}
                              onClick={handleLogoutClick}
                            >
                              {item.name}
                            </span>
                            <div style={{
                              width: '20px',
                              height: '20px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0
                            }}>
                              <img
                                src={item.icon}
                                alt={item.name}
                                className={styles.subIcon}
                                style={{ 
                                  width: '18px',
                                  height: '18px',
                                  objectFit: 'contain',
                                  display: 'block'
                                }}
                              />
                            </div>
                          </li>
                        ))}
                    </ul>
                  </div>
                )}
              </div>
            ) : (
              <>
                {navItems1.find((item) => item.logIn) && (
                  <span
                    style={{
                      display: "flex",
                      flexDirection: "row-reverse",
                      paddingLeft: "10px",
                      paddingRight: "10px",
                    }}
                  >
                    <span
                      style={{
                        display: isMobile ? 'inline' : 'block',
                        //display: "block",
                        marginLeft: "10px",
                        transform: language == "ar" ? "" : "scaleX(-1)",
                      }}
                    >
                      {arrow}
                    </span>
                    <Link
                      to="/home/login"
                      onClick={() => {
                        setOpenDropdown(null);
                        setIsHamburgerOpen(false);
                      }}
                      className={`${styles.loginButton} ${styles.navButton}`}
                    >
                      {direction == "rtl" ? "تسجيل الدخول" : "Sign In"}
                    </Link>
                  </span>
                )}
              </>
            )}
            <div className={styles.cartIcons}>
              {/* Custom Cart Icon */}
              <CustomCartIcon onClick={() => { if (isMobile) setIsHamburgerOpen(false); }} />
            </div>
          </div>
        </div>
        <button className={styles.langbtn} onClick={toggleLanguage}>
          {language === "ar" ? "English" : "العربية"}
        </button>
        <div className={styles.hamburger} onClick={toggleHamburger}>
          {isHamburgerOpen ? (
            <span className={styles.closeIcon}>X</span>
          ) : (
            <>
              <div></div>
              <div></div>
              <div></div>
            </>
          )}
        </div>
      </nav>
    </div>
  );
};

export default Navbar;
//Navbar component to display the navigation bar